import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { DatePicker, Row, Col, TimePicker, Button } from 'antd';
import Input from '../../ui/Input';
import Collapse, { Panel } from '../../ui/Collapse';
import { PlusOutlined } from '@ant-design/icons';
import moment from 'moment';

const { RangePicker } = DatePicker;
const dateFormat = 'MM/DD/YYYY';
const itemFormat = 'HH:mm';
interface propsTypes {
    addLoading: void | any,
    currentForm: any,
    index: number,
    transportation: void | any
}
interface dataType {
    startDatePicker: string,
    operationtime: [
        {
            dayoftheweek: string,
            starttime: string,
            endtime: string
        },
        {
            dayoftheweek: string,
            starttime: string,
            endtime: string
        },
        {
            dayoftheweek: string,
            starttime: string,
            endtime: string
        },
        {
            dayoftheweek: string,
            starttime: string,
            endtime: string
        },
        {
            dayoftheweek: string,
            starttime: string,
            endtime: string
        },
        {
            dayoftheweek: string,
            starttime: string,
            endtime: string
        },
        {
            dayoftheweek: string,
            starttime: string,
            endtime: string
        },

    ]
}
const OperationTime = (props: propsTypes | any) => {
    const { value, onChange } = props;
    const [operationValue, updateValue] = useState(value)
    const formOperationChange = (name: string, value: any) => {
        const oldValue = [...operationValue];
        const nameArr = name.split('_');
        const newValue = oldValue.map((item, index) => {
            if (index === parseInt(nameArr[1])) {
                return {
                    ...item,
                    [nameArr[0]]: value
                }
            }
            return item;
        });
        updateValue(newValue);
        onChange(newValue);
    }
    return (<div>
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: 34, marginTop: 30 }}>
            <div style={{ display: 'flex', flexDirection: 'column-reverse', marginRight: 5, fontWeight: 'bold', }}>
                <div style={{ height: 35 }}>Close</div>
                <div style={{ height: 35 }}>Open</div>
            </div>
            {operationValue && operationValue.length > 0 && operationValue.map(
                (item: any, index: number) => {
                    return (
                        <div className="db-week-wrap" style={{ flex: 1, 'userSelect': 'none' }} key={`operationtime${index}`}>
                            <div style={{ fontSize: 14, fontWeight: 500, }}>
                                {item.dayoftheweek}
                            </div>
                            <div style={{ display: 'none' }}>
                                <Input value={item.dayoftheweek} style={{ display: 'none' }} name={`dayoftheweek_${index}`} />
                            </div>
                            <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', padding: '20 0' }}>
                                <div style={{ height: 40, lineHeight: '40px', width: '80%', margin: 'auto', cursor: 'pointer' }}>
                                    <TimePicker value={item.starttime} onChange={(value) => formOperationChange(`starttime_${index}`, value)} name={`starttime_${index}`} format={itemFormat} />
                                </div>
                            </div>
                            <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', borderTop: '0', padding: '20 0' }}>
                                <div style={{ height: 40, lineHeight: '40px', width: '80%', margin: 'auto', cursor: 'pointer' }}>
                                    <TimePicker value={item.endtime} onChange={(value) => formOperationChange(`endtime_${index}`, value)} name={`endtime_${index}`} format={itemFormat} />
                                </div>
                            </div>
                        </div>
                    )
                }
            )}
        </div>
    </div>);
}
const Schedule = forwardRef((props: propsTypes | any, ref: any) => {
    const { value, onChange, onChangeItem } = props;
    const schedule = value ? value : [getNewSchedule()]
    const getDefaultSchedule = (schedule: dataType[]) => Array.from(schedule).map((v, k) => `${k}`);
    const [defaultSchedule, setDefaultSchedule] = useState(getDefaultSchedule(schedule))
    const [refreshSchedule, setRefreshSchedule] = useState(0)
    const [scheduleValue, updateValue] = useState(formatDate(value ? value : [getNewSchedule()], false));
    useImperativeHandle(ref, () => ({
        resetSchedule: () => {
            const newSchedule: Array<any> = [getNewSchedule()];
            setRefreshSchedule(refreshSchedule + 1)
            setDefaultSchedule(getDefaultSchedule(newSchedule))
            updateValue(newSchedule)
            onChange(formatDate(newSchedule.filter((item: Object) => item), true));
        }
    }))
    const addSchedule = () => {
        onChangeItem()
        const newValue = scheduleValue ? scheduleValue.concat(getNewSchedule()) : [];
        updateValue(newValue);
        setDefaultSchedule(getDefaultSchedule(newValue))
        setRefreshSchedule(refreshSchedule + 1)
        onChange(formatDate(newValue.filter((item: Object) => item), true));
    }
    const deleteSchedule = (index: number) => {
        const newScheduleList = scheduleValue.filter((item: any) => item)
        if (newScheduleList.length === 1) {
            const newValue = scheduleValue ? scheduleValue.map((item: any, _index: number) => {
                if (_index === index) {
                    item.startDatePicker = '';
                    item.operationtime = [
                        {
                            dayoftheweek: "Mon",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Tue",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Wed",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Thu",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Fri",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Sat",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Sun",
                            starttime: "",
                            endtime: ""
                        },

                    ]
                }
                return item;
            }) : [];
            updateValue(newValue);
            onChange(formatDate(newValue.filter((item: Object) => item), true));
        } else {
            const newValue = scheduleValue ? scheduleValue.map((item: any, _index: number) => {
                if (_index === index && value.length > 1) {
                    return null;
                }
                return item;
            }) : [];
            updateValue(newValue);
            onChange(formatDate(newValue.filter((item: Object) => item), true));
        }
    }
    const formChange = (name: string, value: any) => {
        onChangeItem()
        const oldValue = [...scheduleValue];
        const nameArr = name.split('_');
        const newValue = oldValue.map((item, index) => {
            if (index === parseInt(nameArr[1])) {
                return {
                    ...item,
                    [nameArr[0]]: value
                }
            }
            return item;
        });
        updateValue(newValue);
        onChange(formatDate(newValue.filter((item: Object) => item), true));
    }
    const operationTimeChange = (ot: Array<Object>, _index: number) => {
        onChangeItem()
        const newValue = scheduleValue.map((item: Object, index: number) => {
            if (index === _index) {
                return {
                    ...item,
                    operationtime: ot
                }
            }
            return item;
        });
        updateValue(newValue);
        onChange(formatDate(newValue.filter((item: Object) => item), true));
    }
    return (<>
        <div className='row-marginbottom'></div>
        <div style={{ marginLeft: 16, marginRight: 16 }}>
            <Collapse
                defaultActiveKey={defaultSchedule}
                key={refreshSchedule}
                multiCollapseButton
            >
                {scheduleValue?.map((item1: any, j: any) => (
                    <React.Fragment key={j}>
                        {item1 ? <Panel
                            header={`Schedule${j + 1}`}
                            key={j}
                            deleteButton={{
                                action: () => deleteSchedule(j),
                                title: `Are you sure you want to delete Schedule ${j + 1}?`,
                            }}
                        >
                            <div style={{ marginLeft: 8, marginRight: 8 }}>
                                <Row gutter={24}>
                                    <Col span={6} style={{ display: 'none' }}>
                                        <Input style={{ display: 'none' }} name={`scheduleid_${j}`} />
                                    </Col>
                                    <Col span={12}>
                                        <div>Start Date ~ End Date</div>
                                        <RangePicker value={item1.startDatePicker} onChange={(value) => formChange(`startDatePicker_${j}`, value)} name={`startDatePicker_${j}`} format={dateFormat} />
                                    </Col>
                                </Row>
                                <OperationTime value={item1.operationtime} onChange={(value: Array<Object>) => operationTimeChange(value, j)} />
                            </div>
                        </Panel> : null}
                    </React.Fragment>
                ))}
            </Collapse>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {scheduleValue ? <Button
                    type="link"
                    onClick={addSchedule}
                    icon={<PlusOutlined />}
                    style={{ display: 'flex', alignItems: 'center', background: '#fff', float: 'right' }}
                >
                    Add Schedule {scheduleValue.length + 1}
                </Button> : null}
            </div>
        </div>
    </>)
})
function formatDate(formatArr: Array<Object>, isToString: boolean) {
    if (isToString) {
        formatArr = formatArr ? formatArr : [];
        const newArr = formatArr.map((item: any) => {
            const { startDatePicker, ...restItem } = item;
            return {
                ...restItem,
                startdate: startDatePicker ? startDatePicker[0].format('MM/DD/YYYY') : '',
                enddate: startDatePicker ? startDatePicker[1].format('MM/DD/YYYY') : '',
                operationtime: item.operationtime ? item.operationtime.map((ot: any) => {
                    return {
                        ...ot,
                        starttime: ot.starttime ? ot.starttime.format('HH:mm') : '',
                        endtime: ot.endtime ? ot.endtime.format('HH:mm') : ''
                    }
                }) : [getNewSchedule()]
            }
        });
        return newArr;
    } else {
        const itemFormat = 'HH:mm';
        formatArr = formatArr ? formatArr : [];
        const newArr = formatArr.map((item: any) => {
            const { startdate, enddate, ...restItem } = item;
            return {
                ...restItem,
                startDatePicker: startdate && enddate ? [moment(startdate), moment(enddate)] : '',
                operationtime: item.operationtime ? item.operationtime.map((ot: any) => {
                    return {
                        ...ot,
                        starttime: ot.starttime ? moment(ot.starttime, itemFormat) : '',
                        endtime: ot.endtime ? moment(ot.endtime, itemFormat) : ''
                    }
                }) : [getNewSchedule().operationtime]
            }
        });
        return newArr;

    }
}
function getNewSchedule() {
    const newSchedule = {
        startDatePicker: '',
        operationtime: [
            {
                dayoftheweek: "Mon",
                starttime: "",
                endtime: ""
            },
            {
                dayoftheweek: "Tue",
                starttime: "",
                endtime: ""
            },
            {
                dayoftheweek: "Wed",
                starttime: "",
                endtime: ""
            },
            {
                dayoftheweek: "Thu",
                starttime: "",
                endtime: ""
            },
            {
                dayoftheweek: "Fri",
                starttime: "",
                endtime: ""
            },
            {
                dayoftheweek: "Sat",
                starttime: "",
                endtime: ""
            },
            {
                dayoftheweek: "Sun",
                starttime: "",
                endtime: ""
            },

        ]
    }
    return newSchedule;
}
export default Schedule;